import React, { ComponentType, FC } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import * as Sentry from '@sentry/nextjs';

export type ErrorBoundaryProps = {
  children?: React.ReactNode;
  errorFallback?: ComponentType<FallbackProps>;
};

export const LoggedErrorBoundary: FC<ErrorBoundaryProps> = ({ children, errorFallback }) => {
  const defaultErrorFallback = () => {
    return null;
  };

  const logError = (error: Error) => {
    console.log(`Logging error:`, error.message);
    Sentry.captureException(error);
  };

  return (
    <ErrorBoundary FallbackComponent={errorFallback ?? defaultErrorFallback} onError={logError}>
      {children}
    </ErrorBoundary>
  );
};
